var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32922 15C7.3873 15 6.43193 14.6367 5.71877 13.9235C5.01906 13.2238 4.62884 12.2954 4.62884 11.3131C4.62884 10.3308 5.01906 9.38889 5.71877 8.70264L7.61602 6.80535C8.00624 6.41513 8.65212 6.41513 9.04234 6.80535C9.43256 7.19557 9.43256 7.84145 9.04234 8.23167L7.14509 10.129C6.82215 10.4519 6.64723 10.869 6.64723 11.3131C6.64723 11.7571 6.82215 12.1877 7.14509 12.4972C7.80443 13.1565 8.86748 13.1565 9.52682 12.4972L12.514 9.50996C14.2229 7.80106 14.2229 5.02917 12.514 3.32027C10.8051 1.61137 8.0332 1.61137 6.3243 3.32027L3.06791 6.57658C2.38166 7.26283 2.00492 8.1644 2.00492 9.11977C2.00492 10.0751 2.38166 10.9901 3.06791 11.6629C3.45813 12.0531 3.45813 12.699 3.06791 13.0892C2.67769 13.4795 2.0318 13.4795 1.64158 13.0892C0.578565 12.0262 0 10.6134 0 9.1063C0 7.59924 0.578565 6.18638 1.64158 5.12336L4.89797 1.86701C7.38732 -0.622336 11.451 -0.622336 13.9403 1.86701C16.4297 4.35635 16.4297 8.42004 13.9403 10.9094L10.9531 13.8966C10.2265 14.6367 9.28459 15 8.32922 15Z",
    fill: "#6586BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.a4877916c90d13c4d3415ac02d28d030.svg";
export { ForwardRef as ReactComponent };